import axios from 'axios'
import { useAppStore } from '@/shared/store/app.store'
import {
  attachInternalDataHeader,
  setInternalDataProvider,
} from './internal-data.ts'
import { getProEditorInternalData } from './internal-data-provider.ts'

const authApiClient = axios.create()

setInternalDataProvider(getProEditorInternalData)

authApiClient.interceptors.request.use(attachInternalDataHeader)

export const setupAuthInterceptor = (
  getToken: () => Promise<string>,
  onAuthFailure: () => Promise<void>
): number =>
  authApiClient.interceptors.request.use(async (config) => {
    config.headers.Accept = 'application/json'

    try {
      config.headers.Authorization = `Bearer ${await getToken()}`
    } catch (error) {
      console.error(error)
      await onAuthFailure()
      return await Promise.reject(new Error('Authentication failed'))
    }

    const orgId = useAppStore.getState().org
    if (orgId) {
      config.headers['x-assume-org'] = orgId
    }

    return config
  })

export default authApiClient
